// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root for details.

import { Logger, LogRecord, SeverityNumber, logs } from "@opentelemetry/api-logs";
import { InstrumentationConfig } from "@opentelemetry/instrumentation";
import { channel, IStandardEvent, trueFilter } from "diagnostic-channel";
import { console as consolePub } from "diagnostic-channel-publishers";


let logger: Logger;
let logSendingLevel: SeverityNumber;

const subscriber = (event: IStandardEvent<consolePub.IConsoleData>) => {
    const severity = event.data.message.indexOf("Error:") > -1 ? SeverityNumber.ERROR : (event.data.stderr
        ? SeverityNumber.WARN
        : SeverityNumber.INFO);
    if (logSendingLevel <= severity) {
        let message = event.data.message.toString();
        // Message can have a trailing newline
        if (message.lastIndexOf("\n") === message.length - 1) {
            message = message.substring(0, message.length - 1);
        }
        const logRecord: LogRecord = {
            body: message,
            severityNumber: severity
        };
        logger.emit(logRecord);
    }
};

export function enable(config?: InstrumentationConfig & { logSendingLevel?: SeverityNumber }) {
    if (config?.enabled) {
        logger = logs.getLogger("ApplicationInsightsConsoleLogger");
        logSendingLevel = config.logSendingLevel || SeverityNumber.UNSPECIFIED;
        channel.subscribe<consolePub.IConsoleData>("console", subscriber, trueFilter);
    }
}

export function dispose() {
    channel.unsubscribe("console", subscriber);
}
